import React from "react";
import PropTypes from "prop-types";
import { useFormikContext } from "formik";
import { constants } from "@qgiv/core-js";
import { Button } from "@qgiv/core-donor";
import { useDispatch } from "react-redux";

const JoinTeamButton = ({
    id,
    joinTeamButtonLabel,
    setAppTeamModalOpen,
    title,
}) => {
    const dispatch = useDispatch();

    const { setFieldValue, values } = useFormikContext();
    const { Registration_Role, Team_Captain } = values;
    const {
        ENUMS: {
            EntityType: { TEAM },
        },
    } = constants;
    return (
        <Button
            aria-label={`Join team: ${title}`}
            type="button"
            onClick={(e) => {
                e.preventDefault();
                setFieldValue("Team", `${id}`);
                if (Registration_Role[0] !== TEAM) {
                    setFieldValue("Registration_Role", [`${TEAM}`]);
                }
                // Unset team captain if you Join a team after first Creating a team
                if (Team_Captain) {
                    setFieldValue("Team_Captain", false);
                }

                dispatch(setAppTeamModalOpen(false));
            }}
        >
            {joinTeamButtonLabel}
        </Button>
    );
};

JoinTeamButton.propTypes = {
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    joinTeamButtonLabel: PropTypes.string.isRequired,
    setAppTeamModalOpen: PropTypes.func.isRequired,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default JoinTeamButton;
